import React from 'react';

export default function Banner({ bgUrl, imgUrl, title, subTitle }) {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-16 my-24">
      <div 
        className="relative rounded-md overflow-hidden bg-cream-dark p-12 md:p-20 text-center flex flex-col items-center justify-center min-h-[400px]" 
        style={{ backgroundImage: `url(${bgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-crimson/90"></div>
        {imgUrl && <img src={imgUrl} alt="Banner" className="w-16 h-16 object-contain mb-8 relative z-10 brightness-0 invert opacity-90" />}
        <h2 className="font-serif text-4xl md:text-[3.5rem] font-light leading-tight text-white mb-6 relative z-10 max-w-[800px]">{title}</h2>
        <p className="text-lg md:text-xl text-white/80 font-light m-0 relative z-10 max-w-[600px] leading-relaxed">{subTitle}</p>
      </div>
    </div>
  );
}
